import { DASHBOARD_CONFERENCE_LOOKUP_API } from '../constants/routes';
import AuthService from './authservices';

const authService = new AuthService();

export interface ConferenceLookupResponse {
  found: boolean;
  sportCode: string;
  season: number;
  teamCode: number | null;
  teamName: string | null;
  conferenceName: string | null;
  conferenceTidyName: string | null;
  displayLabel: string | null;
}

export interface ConferenceLookupRequest {
  username: string;
  selectedSport: string;
  season: number | string;
}

export function formatConferenceDisplayLabel(
  conferenceName?: string | null,
  conferenceTidyName?: string | null
): string {
  const name = (conferenceName || '').trim();
  const tidy = (conferenceTidyName || '').trim();
  if (tidy && name) {
    return `${tidy} (${name})`;
  }
  if (tidy) {
    return tidy;
  }
  if (name) {
    return name;
  }
  return '';
}

export const MISSING_CONFERENCE_LABEL = '__';

export function conferenceLookupUrl({
  username,
  selectedSport,
  season,
}: ConferenceLookupRequest): URL {
  const requestUrl = new URL(DASHBOARD_CONFERENCE_LOOKUP_API);
  requestUrl.searchParams.set('username', username);
  requestUrl.searchParams.set('selectedSport', selectedSport);
  requestUrl.searchParams.set('season', String(season));
  return requestUrl;
}

export async function fetchConferenceForSeason(
  params: ConferenceLookupRequest
): Promise<ConferenceLookupResponse> {
  const response = await authService.authenticatedFetch(
    conferenceLookupUrl(params).toString(),
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch conference for season');
  }

  return response.json();
}
